// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  prefabModelId: __t.u64().primaryKey().name("prefab_model_id"),
  prefabKey: __t.string().name("prefab_key"),
  assetId: __t.u64().name("asset_id"),
  category: __t.string(),
  defaultScale: __t.f32().name("default_scale"),
  preferInstanced: __t.bool().name("prefer_instanced"),
  castShadow: __t.bool().name("cast_shadow"),
});
